// extracted by mini-css-extract-plugin
module.exports = {"terminal":"rvu_terminal__XXJcd","screenshot":"rvu_screenshot__KV1uR","table":"rvu_table__d0RPC"};